export enum PYTHA_CTRL_TYPE {
    PYTHA_ERASE = 6000,
    PYTHA_MOVE,
    PYTHA_GROUP,
}